<template>
  <custom-dialog class="notify-setting-dialog" width="1200px" :title="title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="tips">
        <i class="icon icon-tishi"></i>
        {{ $t('Common.com_reminder') }}：{{ $t('dms_notify_setting_dialog.wxzdsj') }}，{{ $t('dms_notify_setting_dialog.ISTjbhtsxxgkh') }}
      </div>
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item :label="$t('dms_notify_setting_dialog.chan_pin_xing_hao')">
            <custom-select
              url="productCodeSelectList"
              v-model="formSearch.productCode"
              :props="{ label: 'productCode', value: 'productCode' }"
              width="100%"
              @change="productCodeChange"
              placeholder=""
            ></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_notify_setting_dialog.yu_zhong')">
            <custom-select placeholder="" code="language_type" v-model="formSearch.langCode" @change="languageChange"></custom-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{ $t('Common.com_sel_all') }}</el-checkbox>
        <el-checkbox-group v-model="selectedData" @change="handleCheckedCitiesChange" style="margin-top: 15px">
          <el-checkbox v-for="item in tableList" :label="item.eventId" :key="item.eventId">{{ item.customerCode || item.eventCode }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button :disabled="!selectedData.length" type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 事件通知设置 */

import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {},
  data() {
    return {
      formSearch: {
        productCode: '',
        langCode: '',
      },
      selectedData: [],
      tableList: [],
      checkAll: false,
      isIndeterminate: false,
    };
  },
  computed: {
    title() {
      return this.model.title || this.$t('dms_notify_setting_dialog.sjtzsz');
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    languageChange() {
      this.checkAll = false;
      this.isIndeterminate = false;
      this.selectedData = [];
      this.getTableList();
    },
    productCodeChange() {
      this.checkAll = false;
      this.isIndeterminate = false;
      this.selectedData = [];
      this.getTableList();
    },
    handleCheckAllChange(val) {
      this.selectedData = val ? this.tableList.map(item => item.eventId) : [];
      this.checkAll = false;
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.tableList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableList.length;
    },
    closeDialog() {
      this.visible = false;
    },
    getTableList() {
      this.$getJSON(apis.eventListForProduct, this.formSearch).then((res) => {
        this.tableList = res.data;
      });
    },
    onConfirm() {
      const reqData = this.tableList.map(item => ({
        eventId: item.eventId,
        isPushMsg: this.selectedData.includes(item.eventId) ? 1 : 0,
      }));
      this.$postJSON(apis.eventSetNotice, reqData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
  },
  created() {},
  mounted() {
    this.getTableList();
  },
};
</script>

<style lang="scss">
.notify-setting-dialog {
  .tips {
    padding-left: 10px;
    background: rgba(249, 200, 81, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: rgba(108, 117, 125, 1);
    .icon {
      color: rgba(249, 200, 81, 1);
      margin-right: 10px;
    }
  }
}
</style>
